import { useState } from 'react';

interface BatchApprovalModalProps {
    isOpen: boolean;
    onClose: () => void;
    selectedCount: number;
    onSave: (decision: string, justification: string, observation: string) => void;
}

export default function BatchApprovalModal({ isOpen, onClose, selectedCount, onSave }: BatchApprovalModalProps) {
    const [decision, setDecision] = useState('Pendente');
    const [justification, setJustification] = useState('');
    const [observation, setObservation] = useState('');

    if (!isOpen) return null;

    const handleSubmit = () => {
        onSave(decision, justification, observation);
        onClose();
    };

    const getDecisionColor = (dec: string) => {
        switch (dec) {
            case 'Aprovado': return 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200';
            case 'Reprovado': return 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200';
            case 'Pré-aprovado': return 'bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200';
            default: return 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-200';
        }
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white dark:bg-slate-800 rounded-lg shadow-xl w-full max-w-2xl mx-4">
                <div className="p-6 border-b border-gray-200 dark:border-slate-700">
                    <h2 className="text-xl font-semibold text-gray-900 dark:text-gray-100">
                        Aprovação em Lote
                    </h2>
                    <p className="text-sm text-gray-600 dark:text-gray-400 mt-1">
                        {selectedCount} {selectedCount === 1 ? 'registro selecionado' : 'registros selecionados'}
                    </p>
                </div>

                <div className="p-6 space-y-4">
                    {/* Decisão */}
                    <div>
                        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                            Decisão *
                        </label>
                        <div className="grid grid-cols-2 gap-3">
                            {['Pendente', 'Aprovado', 'Reprovado', 'Pré-aprovado'].map((dec) => (
                                <button
                                    key={dec}
                                    type="button"
                                    onClick={() => setDecision(dec)}
                                    className={`px-4 py-2 rounded-lg font-medium transition-all ${
                                        decision === dec
                                            ? getDecisionColor(dec)
                                            : 'bg-gray-100 text-gray-700 dark:bg-slate-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-slate-600'
                                    }`}
                                >
                                    {dec}
                                </button>
                            ))}
                        </div>
                    </div>

                    {/* Justificativa */}
                    <div>
                        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                            Justificativa
                        </label>
                        <textarea
                            value={justification}
                            onChange={(e) => setJustification(e.target.value)}
                            rows={3}
                            className="w-full px-3 py-2 border border-gray-300 dark:border-slate-600 rounded-lg focus:ring-2 focus:ring-blue-500 dark:focus:ring-blue-400 focus:border-transparent bg-white dark:bg-slate-700 text-gray-900 dark:text-gray-100"
                            placeholder="Digite a justificativa da decisão..."
                        />
                    </div>

                    {/* Observação */}
                    <div>
                        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                            Observação
                        </label>
                        <textarea
                            value={observation}
                            onChange={(e) => setObservation(e.target.value)}
                            rows={3}
                            className="w-full px-3 py-2 border border-gray-300 dark:border-slate-600 rounded-lg focus:ring-2 focus:ring-blue-500 dark:focus:ring-blue-400 focus:border-transparent bg-white dark:bg-slate-700 text-gray-900 dark:text-gray-100"
                            placeholder="Digite observações adicionais..."
                        />
                    </div>
                </div>

                <div className="p-6 border-t border-gray-200 dark:border-slate-700 flex justify-end gap-3">
                    <button
                        onClick={onClose}
                        className="px-4 py-2 bg-gray-200 dark:bg-slate-700 text-gray-700 dark:text-gray-300 rounded-lg hover:bg-gray-300 dark:hover:bg-slate-600 transition-colors"
                    >
                        Cancelar
                    </button>
                    <button
                        onClick={handleSubmit}
                        className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors"
                    >
                        Salvar Aprovação em Lote
                    </button>
                </div>
            </div>
        </div>
    );
}
